import React, { useState } from "react";
import "./style.scss";
import Modal from "react-modal";
import pl from "date-fns/locale/pl";
import { DayPicker } from "react-day-picker";
import { addDays, format } from "date-fns";
import { useTranslation } from "react-i18next";
import EAButton from "../../app/components/shared/Buttons/EAButton";

interface IProps {
  value: string;
  label: string;
  name: string;
  setDate: (value: string) => void;
  assortIds: string;
}

const InputDate: React.FC<IProps> = ({ value, label, name, setDate, assortIds }: IProps) => {
  const [open, setOpen] = useState(false);
  const [clicked, setClicked] = useState(false);
  const { t } = useTranslation();
  const onSelectDate = (date: Date | undefined) => {
    setClicked(true);
    if (date) setDate(format(date, "yyyy-MM-dd"));
    setOpen(false);
  };

  const getMinDate = () => {
    if (assortIds === "0,480") {
      // TUTAJ W IF DODAJEMY NA SZTYWNO ID ASORTYMENTU W KTÓRYM FILTRUJE NAM PO DATACH
      return addDays(new Date(), 14); //DODAJEMY 14 DNI DO AKTUALNEJ DATY
    } else {
      return new Date();
    }
  };

  const getMaxDate = () => {
    return addDays(new Date(), 90);
  };

  return (
    <React.Fragment>
      <div className={"form-input-date"}>
        <label htmlFor={name}>{label}</label>
        <EAButton title={!clicked ? t("wybierz_dzien") : value} onClick={() => setOpen(true)} />
      </div>

      {open && (
        <Modal
          isOpen={open}
          onRequestClose={() => setOpen(false)}
          contentLabel="modal"
          className="modal-calendar"
          style={{ content: { minWidth: "40vmin", maxWidth: "60vmin" } }}
        >
          <div className="calendar">
            <DayPicker
              mode="single"
              locale={pl}
              selected={new Date(value)}
              fromDate={getMinDate()}
              toDate={getMaxDate()}
              onSelect={onSelectDate}
              showOutsideDays
              modifiersClassNames={{
                selected: "my-selected",
                today: "my-today",
              }}
            />
          </div>
        </Modal>
      )}
    </React.Fragment>
  );
};

export default InputDate;
